import React from 'react';

import { TextField } from '@mui/material';

interface Props {
  ariaLabel: string;
  value?: string;
  onChange: (value: string) => void;
}

export default function BlackoutDateField({ ariaLabel, onChange, value }: Props) {
  return (
    <TextField
      fullWidth
      inputProps={{ 'aria-label': ariaLabel }}
      size="small"
      type="date"
      value={value?.slice(0, 10) ?? ''}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
